export abstract class IRuntime {
  abstract isShutdownRequested(): Promise<boolean>;
  abstract requestShutdown(): Promise<void>;
}
